
    <portal-integration-status
      [text]="text$ | async"
      [integrated]="isIntegrated$ | async"
      [synchronised]="isSynchronised$ | async"
    ></portal-integration-status>
  